<div class="way-component--filterable-component main">

  <section class="header">
    <header class="way-component--header">
      <div class="way-component--header-title">{{ "MANAGE_FAMILY_USERS" | translate }}</div>
    </header>
    <section class="header-content">
      <!-- Family input field -->
      <mat-form-field appearance="outline">
        <mat-label>{{ "FAMILY" | translate }}</mat-label>
        <input type="text"
          name="family"
          [placeholder]="'FAMILY' | translate"
          aria-label="Family"
          matInput
          required
          [formControl]="familyFormControl"
          [matAutocomplete]="familyAutocomplete">
          @if ((familiesLoading$ | async) === true) {
            <mat-hint>
              <mat-progress-spinner mode="indeterminate"
                diameter="12"
              strokeWidth="2"></mat-progress-spinner>
              {{ "LOADING_DATA" | translate }}
            </mat-hint>
          }
          <!-- Family description -->
          @if (familyFormControl.valid) {
            <mat-hint>
              {{ familyFormControl.value?.description || ('NO_DESCRIPTION_AVAILABLE' | translate) }}
            </mat-hint>
          }
          <!-- Errors management -->
          @if (familyFormControl.errors) {
            <mat-error>
              <fa-icon icon="circle-exclamation"></fa-icon>
              @if (familyFormControl.errors?.invalidFamily) {
                {{ "MANAGE_FAMILY_USERS_INVALID_FAMILY" | translate }}
              }
              @if (familyFormControl.errors?.required) {
                {{ "MANAGE_FAMILY_USERS_REQUIRED_FAMILY" | translate }}
              }
            </mat-error>
          }
          <mat-autocomplete #familyAutocomplete="matAutocomplete"
            panelWidth="fit-content"
            [displayWith]="getFamilyName">
            @for (parentFamily of parentFamilies$ | async; track parentFamily) {
              <mat-optgroup
                [label]="parentFamily.name">
                @for (family of parentFamily.families; track family) {
                  <mat-option
                    [value]="family">
                    <span>{{ family.name }}</span>
                    @if (family.description) {
                      <small class="caption"
                      >&nbsp;&#124;&nbsp;{{ family.description }}</small>
                    }
                  </mat-option>
                }
              </mat-optgroup>
            }
          </mat-autocomplete>
        </mat-form-field>
      </section>
    </section>

    @if (familyFormControl.valid) {
      <div class="way-filter-container"
        [appHidden]="!(dataSource.data?.length || (usersLoading$ | async))">
        @if (familyFormControl.valid) {
          <app-filter
            [dataForFilter$]="users$"
          [parentSourceView]="viewName"></app-filter>
        }
      </div>
      @if (dataSource.data?.length || (usersLoading$ | async)) {
        <div class="way-component--header">
          <span class="way-component--header-title">
            <span>{{ 'USERS' | translate }}</span>
            @if ((usersLoading$ | async) === false) {
              <span
              class="mat-body-strong"> ({{ dataSource?.data?.length }})</span>
            }
          </span>
          <div class="way-component--header-buttons">
            <button mat-stroked-button
              color="primary"
              [disabled]="massUpdateDisabled || (usersLoading$ | async)"
              (click)="onClickMassUpdateRole()">
              <fa-icon icon="pencil-alt"></fa-icon>
              {{ 'USERS_MASS_UPDATE' | translate }}
            </button>
            <button mat-stroked-button
              color="primary"
              [disabled]="usersLoading$ | async"
              (click)="refreshData()">
              <fa-icon icon="sync-alt"></fa-icon>
              {{ 'REFRESH_DATA' | translate }}
            </button>
          </div>
        </div>
        <div class="way-table--main-container">
          <div class="table-container custom-scrollbar">
            <table class="way-table"
              mat-table
              matSort
              matSortActive="famRightLevel"
              matSortDirection="desc"
              [dataSource]="dataSource"
              aria-label="manage family user table">
              <!-- Columns -->
              <ng-container matColumnDef="data">
                <th mat-header-cell
                  mat-sort-header
                  scope="col"
                *matHeaderCellDef> {{ 'USER' | translate }} </th>
                <td mat-cell
                *matCellDef="let row"> {{row.data}} </td>
              </ng-container>
              <ng-container matColumnDef="email">
                <th mat-header-cell
                  mat-sort-header
                  scope="col"
                *matHeaderCellDef> {{ 'EMAIL' | translate }} </th>
                <td mat-cell
                *matCellDef="let row"> {{row.email}} </td>
              </ng-container>
              <ng-container matColumnDef="famRightLevel">
                <th mat-header-cell
                  mat-sort-header
                  scope="col"
                *matHeaderCellDef> {{ "RIGHT_LEVEL" | translate }} </th>
                <td mat-cell
                  *matCellDef="let row">
                  <div [matTooltip]="!!row.fromGroupId ? ('RIGHTS_ONLY_FROM_GROUP' | translate) : ('RIGHTS_FORBIDDEN_SELF_ASSIGN' | translate)"
                    [matTooltipDisabled]="!row.fromGroupId && currentUserId !== row.data">
                    <app-role-selection [role]="row.famRightLevel"
                      [editableRoleLimit]="selectedFamily.level"
                      [disabled]="!!row.fromGroupId || currentUserId === row.data"
                      color="primary"
                    (selectedRoleChange)="onRoleSelectionChange(row, $event)"></app-role-selection>
                  </div>
                  @if (row.updating) {
                    <div
                      class="row-loader">
                      <mat-progress-spinner color="primary"
                        mode="indeterminate"
                      diameter="32"></mat-progress-spinner>
                    </div>
                  }
                </td>
              </ng-container>
              <tr mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row
              *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            @if (usersLoading$ | async) {
              <div
                class="table-loader">
                <mat-progress-spinner color="primary"
                  mode="indeterminate"
                  diameter="32">
                </mat-progress-spinner>
              </div>
            }
          </div>
          <mat-paginator class="way-table--footer"
            (page)="scrollUp()"
            [pageSizeOptions]="[25, 50, 100]">
          </mat-paginator>
        </div>
      } @else {
        <div class="fill-panel empty-state">
          <div class="fa-stack fa-4x icon">
            <fa-stack>
              <fa-icon icon="ghost" stackItemSize="2x" class="icon-back"></fa-icon>
              <fa-icon icon="scroll" class="icon-front" data-fa-transform="shrink-8"></fa-icon>
            </fa-stack>
          </div>
          <div>
            <p class="mat-subheading-2">{{ "NO_DATA_FOUND" | translate }}</p>
          </div>
        </div>
      }
    } @else {
      <app-empty-state-fill-field [subtitle]="'MANAGE_FAMILY_USERS_TRY_FAMILY' | translate"></app-empty-state-fill-field>
    }



  </div>
